import { useUpdateUserRolesMutation, useSetUserRoleInGroupMutation } from '../userApi';
import { enqueueSnackbar } from 'notistack';
import i18next from 'i18next';

export const useUserActions = () => {
  const [updateUserRolesTrigger] = useUpdateUserRolesMutation();
  const [setUserRoleInGroupTrigger] = useSetUserRoleInGroupMutation();

  const updateUserRoles = async ({ id, roles }) => {
    try {
      const result = await updateUserRolesTrigger({ id, roles }).unwrap();
      enqueueSnackbar(i18next.t('users.updateSuccess'), { variant: 'success' });
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('users.updateFailed'), { variant: 'error' });
      throw error;
    }
  };

  const setUserRoleInGroup = async ({ userId, circleId, role }) => {
    try {
      const result = await setUserRoleInGroupTrigger({ userId, circleId, role }).unwrap();
      enqueueSnackbar(i18next.t('users.updateGroupRoleSuccess'), { variant: 'success' });
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('users.updateGroupRoleFailed'), { variant: 'error' });
      throw error;
    }
  };

  return {
    updateUserRoles,
    setUserRoleInGroup,
  };
};

